import { render, staticRenderFns } from "./PlanPrices.vue?vue&type=template&id=39ae8048&scoped=true&lang=pug&"
import script from "./PlanPrices.vue?vue&type=script&lang=js&"
export * from "./PlanPrices.vue?vue&type=script&lang=js&"
import style0 from "./PlanPrices.vue?vue&type=style&index=0&id=39ae8048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae8048",
  null
  
)

export default component.exports